import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Table } from '../util';
import { Button } from '../util/buttons';
import { createTimezonedDate } from '../util/date';
import TemplateUploadErrorsModal from '../util/files/TemplateUploadErrorsModal';
const TechnicalNarrativeTemplateUploadSection = _ref => {
  let {
    loading,
    setLoading,
    claimGroup,
    handleToaster,
    uploadDocument,
    documentUrl,
    uploadButtonText,
    downloadButtonText,
    statuses,
    showDownloadButton,
    useFetchStatusWithInterval = () => {}
  } = _ref;
  const hiddenFileInput = useRef(null);
  const [modalShow, setModalShow] = useState(false);
  const {
    importStatus: lastImportStatus,
    setImportStatus: setLastImportStatus,
    interval: fetchImportStatusInterval
  } = useFetchStatusWithInterval({
    claimGroupId: claimGroup.id,
    setLoading
  });
  if ((lastImportStatus === null || lastImportStatus === void 0 ? void 0 : lastImportStatus.import_status) === 'pending' && !(fetchImportStatusInterval !== null && fetchImportStatusInterval !== void 0 && fetchImportStatusInterval.started)) {
    fetchImportStatusInterval.start();
    setLoading(true);
  } else if ((lastImportStatus === null || lastImportStatus === void 0 ? void 0 : lastImportStatus.import_status) !== 'pending' && fetchImportStatusInterval !== null && fetchImportStatusInterval !== void 0 && fetchImportStatusInterval.started) {
    fetchImportStatusInterval.clear();
    loading && setLoading(false);
  }
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const submitUpload = async e => {
    if (e.target.files[0].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setLastImportStatus({
        import_status: 'pending'
      });
      await uploadDocument(e);
      hiddenFileInput.current.value = null;
    } else {
      handleToaster('Please upload docx file', 'warning');
    }
  };
  const generateDocument = () => {
    window.open(documentUrl);
  };
  const rows = () => {
    return ((lastImportStatus === null || lastImportStatus === void 0 ? void 0 : lastImportStatus.import_errors) || []).map(error => ({
      columns: [error]
    }));
  };
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(Table, {
      headers: [{
        text: 'Error'
      }],
      rows: rows(),
      showControls: false
    });
  };
  const renderStatus = () => {
    if (lastImportStatus) {
      switch (lastImportStatus.import_status) {
        case 'imported_successfully':
          return 'Template was imported successfully';
        case 'imported_unsuccessfully':
          return /*#__PURE__*/React.createElement("span", null, "There were errors importing the file.", /*#__PURE__*/React.createElement(Button, {
            style: {
              padding: 0,
              margin: 0
            },
            variant: "link",
            onClick: () => setModalShow(true)
          }, "You can check them here"));
        case 'never_imported':
          return 'Template was never imported';
        default:
          return 'Pending';
      }
    } else {
      return 'Template was never imported';
    }
  };
  const importTableHeaders = [{
    text: 'Date'
  }, {
    text: 'Uploaded By'
  }, {
    text: ''
  }];
  const importTableRows = () => {
    return statuses === null || statuses === void 0 ? void 0 : statuses.filter(im => im.import_status !== 'never_imported').reverse().map(im => ({
      columns: [createTimezonedDate(new Date(im.created_at), true).toCustomLocaleTimeString(), im.uploaded_by, /*#__PURE__*/React.createElement("a", {
        href: im.download_links.url,
        target: "_blank",
        rel: "noreferrer"
      }, im.download_links.filename)]
    }));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TemplateUploadErrorsModal, {
    title: "Import Errors",
    body: modalBody(),
    show: modalShow,
    onHide: () => {
      setModalShow(false);
    }
  }), /*#__PURE__*/React.createElement(Row, {
    className: "scrollable"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: showDownloadButton ? 0 : 3
    },
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: true,
    variant: "info",
    iconPosition: "left",
    size: "md",
    icon: "upload_file",
    loading: loading,
    className: "mb-2",
    id: "upload-technical-template-button",
    onClick: handleClick
  }, uploadButtonText), /*#__PURE__*/React.createElement("div", null, renderStatus()), /*#__PURE__*/React.createElement("input", {
    style: {
      display: 'none'
    },
    type: "file",
    ref: hiddenFileInput,
    "data-testid": "technicalTemplateUploadInput",
    onChange: e => submitUpload(e)
  })), showDownloadButton && /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    iconPosition: "left",
    size: "md",
    icon: "download",
    loading: loading,
    id: "download-technical-template-button",
    className: "mb-4",
    onClick: generateDocument
  }, downloadButtonText))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      offset: 3,
      span: 6
    },
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Table, {
    headers: importTableHeaders,
    rows: importTableRows(),
    showControls: false
  }))));
};
export default TechnicalNarrativeTemplateUploadSection;